<template>
  <div class="style-guide-wrapper">
    <div class="style-guide mb-6">
      <div id="icons" class="h1 mt-8 mb-6" ref="typography">Icons</div>
              <pre>
          Example Props

          size="24"
          name="menu"
          lightModeColour="" (optional - default black)
          darkModeColor="" (optional - default white)

          Sizes: 16, 24, 32, 48, 64, 128 or 256

          Hover for names

          Usage: &#x3C;apio-icon size=&#x22;24&#x22; name=&#x22;ui-calendar&#x22; lightModeColour=&#x22;purple&#x22; darkModeColour=&#x22;cyan&#x22; /&#x3E;

          <div style="display: flex;"><apio-icon size="16" name="menu" /><apio-icon size="24" name="menu" /><apio-icon size="32" name="menu" /></div>
        </pre>
      <v-card outline class="mb-6 pa-8 icons">

        <div>
          <apio-icon size="24" name="menu" />menu
          <apio-icon size="24" name="chevron-down" />
          <apio-icon size="24" name="chevron-left" />
          <apio-icon size="24" name="chevron-right" />
          <apio-icon size="24" name="chevron-right" />
          <apio-icon size="24" name="chevron-up" />
          <apio-icon size="24" name="cross" />
          <apio-icon size="24" name="menu" />
          <apio-icon size="24" name="nav-arrow-left-double" />
          <apio-icon size="24" name="nav-arrow-right-double" />
          <apio-icon size="24" name="nav-chart" />
          <apio-icon size="24" name="nav-cog" />
          <apio-icon size="24" name="nav-layers" />
          <apio-icon size="24" name="nav-status" />
        </div>
        <div>

          <apio-icon size="24" name="ui-calendar" />
          <apio-icon size="24" name="ui-circle-plus" />
          <apio-icon size="24" name="ui-circle-tick-fill" />
          <apio-icon size="24" name="ui-circle-tick-line" />
          <apio-icon size="24" name="ui-dark-mode" />
          <apio-icon size="24" name="ui-edit" />
          <apio-icon size="24" name="ui-error" />
          <apio-icon size="24" name="ui-light-mode" />
          <apio-icon size="24" name="ui-more-A" />
          <apio-icon size="24" name="ui-more-B" />
          <apio-icon size="24" name="ui-org" />
          <apio-icon size="24" name="ui-plus" />
          <apio-icon size="24" name="ui-search" />
          <apio-icon size="24" name="ui-user" />
        </div>
        <div>
          <apio-icon size="24" name="menu" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="chevron-down" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="chevron-left" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="chevron-right" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="chevron-right" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="chevron-up" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="cross" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="menu" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-arrow-left-double" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-arrow-right-double" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-chart" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-cog" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-layers" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="nav-status" lightModeColour="white" darkModeColour="black" />

        </div>
        <div>
          <apio-icon size="24" name="ui-calendar" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-circle-plus" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-circle-tick-fill" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-circle-tick-line" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-dark-mode" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-edit" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-error" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-light-mode" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-more-A" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-more-B" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-org" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-plus" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-search" lightModeColour="white" darkModeColour="black" />
          <apio-icon size="24" name="ui-user" lightModeColour="white" darkModeColour="black" />
        </div>
        <div>
          <apio-icon size="24" name="menu" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="chevron-down" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="chevron-left" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="chevron-right" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="chevron-right" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="chevron-up" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="cross" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="menu" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-arrow-left-double" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-arrow-right-double" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-chart" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-cog" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-layers" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="nav-status" lightModeColour="purple" darkModeColour="cyan" />
        </div>
        <div>
          <apio-icon size="24" name="ui-calendar" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-circle-plus" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-circle-tick-fill" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-circle-tick-line" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-dark-mode" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-edit" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-error" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-light-mode" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-more-A" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-more-B" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-org" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-plus" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-search" lightModeColour="purple" darkModeColour="cyan" />
          <apio-icon size="24" name="ui-user" lightModeColour="purple" darkModeColour="cyan" />
        </div>
        <div>
          <apio-icon size="24" name="menu" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="chevron-down" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="chevron-left" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="chevron-right" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="chevron-right" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="chevron-up" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="cross" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="menu" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-arrow-left-double" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-arrow-right-double" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-chart" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-cog" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-layers" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="nav-status" lightModeColour="cyan" darkModeColour="purple" />
        </div>
        <div>
          <apio-icon size="24" name="ui-calendar" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-circle-plus" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-circle-tick-fill" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-circle-tick-line" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-dark-mode" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-edit" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-error" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-light-mode" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-more-A" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-more-B" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-org" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-plus" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-search" lightModeColour="cyan" darkModeColour="purple" />
          <apio-icon size="24" name="ui-user" lightModeColour="cyan" darkModeColour="purple" />
        </div>
      </v-card>
      <div id="typography" class="h1 my-6" ref="typography">Typography</div>
      <v-card outline class="mb-6 pa-8 typography">
        <div>
          <div class="hero-typography">Hero</div>
          <div class="h1">H1 Headline</div>
          <div class="h2">H2 Headline</div>
          <div class="h3">H3 Headline</div>
          <div class="p1-normal">Paragraph 1 / Normal</div>
          <div class="p1-extra-bold">Paragraph 1 / extra bold</div>
        </div>
        <div>
          <div class="p2-normal">Paragraph 2 / Normal</div>
          <div class="p2-extra-bold">Paragraph 2 / extra bold</div>
          <div class="small-normal">Small / Normal</div>
          <div class="small-extra-bold">Small / extra bold</div>
          <div class="tiny-normal">Tiny / Normal</div>
          <div class="tiny-extra-bold">Tiny / extra bold</div>
          <a>This is a link text - default</a>
        </div>
      </v-card>
      <div id="colours" class="h1 my-6" ref="colours">Colours</div>
      <v-card outline class="mb-6 pa-8 colours">
        <div>
          <div class="colour-swatch h2 apio-blue-black">apio-blue-black</div>
          <div class="colour-swatch h2 apio-magenta">apio-magenta</div>
          <div class="colour-swatch h2 apio-purple">apio-purple</div>
          <div class="colour-swatch h2 apio-cyan">apio-cyan</div>
          <div class="colour-swatch h2 apio-shade-1">apio-shade-1</div>
          <div class="colour-swatch h2 apio-shade-2">apio-shade-2</div>
        </div>
        <div>
          <div class="colour-swatch h2 apio-shade-3">apio-shade-3</div>
          <div class="colour-swatch h2 apio-shade-4">apio-shade-4</div>
          <div class="colour-swatch h2 apio-shade-5">apio-shade-5</div>
          <div class="colour-swatch h2 apio-error">apio-error</div>
          <div class="colour-swatch h2 apio-warning">apio-warning</div>
          <div class="colour-swatch h2 apio-success">apio-success</div>
        </div>
      </v-card>

      <div id="buttons" class="h1 my-6">
        Buttons/Switches<br />
        <h6>
          dash/webroot_src/src/components/Misc/ButtonArrow.vue,
          dash/webroot_src/src/components/Misc/Button.vue
        </h6>
      </div>
      <v-card outline class="mb-6 pa-8 buttons-switches">
        <div>
          <code
            >&#x3C;apio-button&#x3E;Primary (default)
            button&#x3C;/apio-button&#x3E;</code
          >

          <apio-button>Primary (default) button</apio-button>
          <code
            >&#x3C;apio-button button-type=&#x22;secondary&#x22;&#x3E;Secondary
            button&#x3C;/apio-button&#x3E;</code
          >

          <apio-button button-type="secondary">Secondary button</apio-button>
          <code
            >&#x3C;apio-button button-type=&#x22;disabled&#x22;&#x3E;Disabled
            button&#x3C;/apio-button&#x3E;</code
          >

          <apio-button button-type="disabled">Disabled button</apio-button>
          <code
            >&#x3C;apio-button button-type=&#x22;selected&#x22;&#x3E;Selected
            button&#x3C;/apio-button&#x3E;</code
          >

          <apio-button button-type="selected">Selected state</apio-button>

          <code
            >&#x3C;apio-button-arrow
            direction=&#x22;left&#x22;&#x3E;&#x3C;/apio-button-arrow&#x3E;</code
          >
          <apio-button-arrow direction="left"></apio-button-arrow>
          <code
            >&#x3C;apio-button-arrow
            direction=&#x22;right&#x22;&#x3E;&#x3C;/apio-button-arrow&#x3E;</code
          >
          <apio-button-arrow direction="right"></apio-button-arrow>
          <code>&#x3C;apio-dark-light-mode-switch /&#x3E;</code>
          <apio-dark-light-mode-toggle />

          <code
            >&#x3C;apio-pill-switch&#x3E; &#x3C;template
            slot=&#x22;left&#x22;&#x3E;Condensed view&#x3C;/template&#x3E;
            &#x3C;template slot=&#x22;right&#x22;&#x3E;Expanded
            view&#x3C;/template&#x3E; &#x3C;/apio-pill-switch&#x3E;</code
          >

          <div
            style="background: var(--apio-shade-4); padding: 24px; width: 360px"
          >
            <apio-pill-switch>
              <template slot="left">Condensed view</template>
              <template slot="right">Expanded view</template>
            </apio-pill-switch>
          </div>
        </div>
        <div class="buttons-sizes">
          <code
            >&#x3C;apio-button button-type=&#x22;primary&#x22;
            button-size=&#x22;medium&#x22;&#x3E;Primary
            medium&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="primary" button-size="medium"
            >Primary medium</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;primary&#x22;
            button-size=&#x22;small&#x22;&#x3E;Primary
            small&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="primary" button-size="small"
            >Primary small</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;secondary&#x22;
            button-size=&#x22;medium&#x22;&#x3E;Secondary
            medium&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="secondary" button-size="medium"
            >Secondary medium</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;secondary&#x22;
            button-size=&#x22;small&#x22;&#x3E;Secondary
            small&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="secondary" button-size="small"
            >Secondary small</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;disabled&#x22;
            button-size=&#x22;medium&#x22;&#x3E;Disabled
            medium&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="disabled" button-size="medium"
            >Disabled medium</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;disabled&#x22;
            button-size=&#x22;small&#x22;&#x3E;Disabled
            small&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="disabled" button-size="small"
            >Disabled small</apio-button
          >

          <code
            >&#x3C;apio-button button-type=&#x22;selected&#x22;
            button-size=&#x22;medium&#x22;&#x3E;Selected
            medium&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="selected" button-size="medium"
            >Selected medium</apio-button
          >
          <code
            >&#x3C;apio-button button-type=&#x22;selected&#x22;
            button-size=&#x22;small&#x22;&#x3E;Selected
            small&#x3C;/apio-button&#x3E;</code
          >
          <apio-button button-type="selected" button-size="small"
            >Selected small</apio-button
          >
        </div>
      </v-card>

      <div id="form" class="h1 my-6">Form Elements</div>

      <v-card outline class="mb-6 pa-8 form-elements">
        <div>
          <apio-text-field class="mb-8" placeholder="Type here…" />
          <apio-text-field
            class="mb-8"
            placeholder="Type here…"
            label="With supporting label"
            value="Type here…"
            :model="blank"
          />
          <apio-text-field
            class="mb-8"
            placeholder="Disabled..."
            value="Disabled"
            :disabled="true"
          />
          <v-form>
            <validation-provider
              v-slot="{ errors }"
              rules="required|email"
              name="email"
              tag="div"
              class="mb-8"
            >
              <v-text-field
                :validation="true"
                dense
                outlined
                hide-details="auto"
                required
                v-model="email"
                ref="email"
                placeholder="Email"
                autocomplete="username email"
                :class="{ 'apio-error-text-field': errors[0] }"
              >
              </v-text-field>
              <transition name="fade">
                <div class="form-field-error" v-if="errors[0]">
                  <div class="error-icon" />
                  <div>{{ errors[0] }}</div>
                </div>
              </transition>
            </validation-provider>
          </v-form>

      <div style="background-color: var(--apio-shade-4); padding: 16px;">


  <code>&lt;apio-checkbox label=&quot;test&quot; :value=&quot;consentValue&quot; :checked=&quot;testCheckbox&quot; v-model=&quot;testCheckbox&quot; /&gt;</code><br><br>
  <apio-checkbox label="test" :value="consentValue" :checked="testCheckbox" v-model="testCheckbox" />
 <pre>
    Test checkbox #1
    Checked: {{ this.testCheckbox }}
    Value: {{ consentValue }} </pre><br /><br />
  </div>
  <code>&lt;apio-checkbox label=&quot;test&quot; :value=&quot;consentValue1&quot; :checked=&quot;testCheckbox2&quot; v-model=&quot;testCheckbox2&quot;  /&gt;</code><br><br>
  <apio-checkbox label="test" :value="consentValue1" :checked="testCheckbox2" v-model="testCheckbox2"  />
   <pre>
    Test checkbox #2
    Checked: {{ this.testCheckbox2 }}
    Value: {{ consentValue1 }} </pre><br /><br />
      <div style="background-color: var(--apio-shade-4); padding: 16px;">

  <code>Test radio button value: {{ yes_no_question }}</code><br /><br />


  <code>&lt;apio-radio-buttons
    id=&quot;yesNoQuestion&quot;
    v-model=&quot;yes_no_question&quot;
    :options=&quot;yes_no_question_options&quot;
    label=&quot;Example question one&quot;
  /&gt;</code><br><br>
  <pre>
    data() {
      return {
      yes_no_question: true,
      yes_no_question_options: [
        {
          value: true,
          text: "Yes",
        },
        {
          value: false,
          text: "No",
        },
      ]
    },</pre><br/><br/>

  <apio-radio-buttons
    id="yesNoQuestion"
    v-model="yes_no_question"
    :options="yes_no_question_options"
    label="Example question one"
  /></div>
        </div>
        <div>
          <apio-text-area class="mb-8" placeholder="Type here…" />
          <apio-text-area
            class="mb-8"
            placeholder="Type here…"
            label="With supporting label"
            value="Type here…"
          />
          <apio-text-area
            class="mb-8"
            placeholder="Type here…"
            value="Disabled"
            :disabled="true"
          />
          <v-form>
            <validation-provider
              v-slot="{ errors }"
              rules="required|email"
              name="email"
              tag="div"
            >
              <v-textarea
                :validation="true"
                dense
                outlined
                hide-details="auto"
                required
                v-model="email"
                ref="email"
                placeholder="Email"
                autocomplete="username email"
                :class="{ 'apio-error-text-field': errors[0] }"
              >
              </v-textarea>
              <transition name="fade">
                <div class="form-field-error" v-if="errors[0]">
                  <div class="error-icon" />
                  <div>{{ errors[0] }}</div>
                </div>
              </transition>
            </validation-provider>
          </v-form>

          <v-select
            class="mt-8"
            :items="items"
            item-text="name"
            item-value="id"
            :menu-props="{ bottom: true, offsetY: true }"
            placeholder="Please select..."
            outlined
          ></v-select>

          <code>
            &#x3C;apio-date-range-picker
            @update=&#x22;updateDateRange&#x22;
            :date-range=&#x22;dateRange&#x22;&#x3E;
          &#x3C;/apio-date-range-picker&#x3E;</code
          ><br />

          <code>Where date range equals :-</code><br>
          <pre>{{ dateRange }}</pre>

          <apio-date-range-picker
            @update="updateDateRange"
            :date-range="dateRange">
          </apio-date-range-picker>
        </div>
      </v-card>

      <div id="tables" class="h1 my-6">Tables</div>

      <v-card outline class="mb-6 pa-8 tables">

        <div>
          <div style="display: flex; height: 48px; align-items: center">
            <apio-switch
              v-on:change="showFilter = !showFilter"
              label="Toggle filter on off"
            ></apio-switch>
          </div>
          <data-table
            v-if="users"
            :show-filter="showFilter"
            :headers="fields"
            :items="users"
          >
            <template v-slot:[`item.show_details`]="{ item }">
              <v-btn
                :ripple="false"
                color="info"
                @click="toggleDialog(true, 'edit', item)"
                >Edit</v-btn
              >
            </template>

            <template v-slot:[`item.md_clients`]="{ item }">
              <v-chip
                v-for="client in item.md_clients"
                x-small
                label
                :key="client"
                color="primary"
                >{{ client === "*" ? "All" : client }}</v-chip
              >
            </template>
          </data-table>
        </div>
      </v-card>

      <div id="banners" class="h1 my-6">Banners</div>
      <v-card outline class="mb-6 pa-8 banners">

        <div>

                   <apio-banner :size="'tall'"  v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'" :icon="'users'" :type="'add_user'" :title-text-size="'h1'">
                <apio-button button-type="secondary" slot="button"  style="text-transform: none">Add users</apio-button>
            </apio-banner>

            <apio-banner  v-else :icon="'users'" :type="'add_user'" :title-text-size="'h1'" :content-text="`Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laud
antium, totam rem apereaqe`">
                <apio-button button-type="secondary" slot="button"  style="text-transform: none">Add users</apio-button>
            </apio-banner>




            <apio-banner v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"  :size="'tall'" :title="'You haven’t created any apps yet'"  :type="'add_app'" :title-text-size="'h1'" :content-text="`Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laud
antium, totam rem apereaqe`">
                <apio-button button-type="secondary" slot="button"  style="text-transform: none">Create app</apio-button>
            </apio-banner>

                        <apio-banner v-else :size="'small'" :title="'You haven’t created any apps yet'" :type="'add_app'" :title-text-size="'h1'">
                <apio-button button-type="secondary" slot="button"  style="text-transform: none">Create app</apio-button>
            </apio-banner>





            <apio-banner v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"  :size="'tall'" :title-text-size="'h1'" :title="'Create your first organisation'" :content-text="`Sed ut perspiciatis unde omnis iste natus error
sit voluptatem accusantium doloremque laud
antium, totam rem aperiam eaqew uptatem
accusantium dolorem unde omnis iste na
ntium doloremque lauda.`" :background="'vibrant'" :content-text-colour="'white'" :title-text-colour="'white'">
               <apio-button button-type="secondary" slot="button" style="text-transform: none">Create organisation</apio-button>
            </apio-banner>

            <apio-banner v-else :title="'Create your first organisation'" :content-text="`Sed ut perspiciatis unde omnis iste natus error
sit voluptatem accusantium doloremque laud
antium, totam rem aperiam eaqew uptatem
accusantium dolorem unde omnis iste na
ntium doloremque lauda.`" :background="'vibrant'" :content-text-colour="'white'" :title-text-colour="'white'">
               <apio-button  button-type="secondary" slot="button" style="text-transform: none">Create organisation</apio-button>
            </apio-banner>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "StyleGuide",
  components: {
    // ApioButton: () => import("@/components/Misc/Button.vue"),
    ApioButtonArrow: () => import("@/components/Misc/ButtonArrow.vue"),
    ApioDarkLightModeToggle: () =>
      import("@/components/Misc/DarkLightModeToggle.vue"),
    ApioPillSwitch: () => import("@/components/Misc/PillSwitch.vue"),
    ApioTextField: () => import("@/components/Form/TextField.vue"),
    ApioTextArea: () => import("@/components/Form/TextArea.vue"),
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
    ApioDateRangePicker: () => import("@/components/Misc/DateRangePicker.vue"),
    ApioSwitch: () => import("@/components/Misc/Switch.vue"),
    ApioBanner: () => import("@/components/Banner/Banner.vue"),
  },
  methods: {
    scrollTo(id, yOffset = -124) {
      const el = document.getElementById(id);
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    },
    updateDateRange(val) {
      this.dateRange = val
    },
    updateCheckboxValue(val) {
      this.testCheckbox = val
    },
    updateCheckboxValue2(val) {
      this.testCheckbox2 = val
    },
    updateRadioValue(val) {
      this.testRadioButton = val
    }
  },
  computed: {
    separator() {
      return this.localeData;
    },
  },
  data() {
    return {
      'consentValue': 'Some value',
      'consentValue1': 'Another value',
      yes_no_question: true,
      yes_no_question_options: [
        {
          value: true,
          text: "Yes",
        },
        {
          value: false,
          text: "No",
        },
      ],
      testRadioButton: 'a',
      testCheckbox: true,
      testCheckbox2: false,
      email: "bob@bo",
      showFilter: false,
      password: "",
      checked: true,
      unchecked: false,
      ex7: "selected",
      dateRange: {
        startDate: dayjs().subtract("14", "day"),
        endDate: dayjs(),
      },
      localeData: {
        format: "dd/mm/yyyy",
        separator: " - ",
      },
      fields: [
        {
          value: "username",
          text: "Email",
        },
        {
          value: "md_fullname",
          text: "Full Name",
        },
        {
          value: "md_clients",
          text: "Clients",
        },
        {
          value: "show_details",
          text: "Details",
        },
      ],
      users: [
        {
          ID: "260b9358-b11e-f9d5-96a5-f978d424031d",
          aliases: [
            {
              canonical_id: "260b9358-b11e-f9d5-96a5-f978d424031d",
              creation_time: "2021-01-20T08:11:20.226271Z",
              id: "1ed6194f-8d58-e6c5-01f6-f10a81476495",
              last_update_time: "2021-01-20T08:11:20.226271Z",
              merged_from_canonical_ids: null,
              metadata: null,
              mount_accessor: "auth_userpass_068432cc",
              mount_path: "auth/userpass/",
              mount_type: "userpass",
              name: "dev",
            },
          ],
          creation_time: "2021-01-20T08:11:20.226268Z",
          direct_group_ids: [],
          disabled: false,
          group_ids: [],
          id: "260b9358-b11e-f9d5-96a5-f978d424031d",
          inherited_group_ids: [],
          last_update_time: "2021-01-20T08:11:20.374825Z",
          md_admin: "true",
          md_build: "true",
          md_clients: ["*"],
          md_email: "dev@gpmd.co.uk",
          md_fullname: "Dev Dude",
          md_package: "full",
          merged_entity_ids: null,
          metadata: {
            admin: "1",
            build: "1",
            clients: "*",
            email: "dev@gpmd.co.uk",
            fullname: "Dev Dude",
            package: "full",
          },
          name: "entity_90106125",
          namespace_id: "root",
          policies: ["id:260b9358-b11e-f9d5-96a5-f978d424031d", "admin"],
          username: "dev",
        },
      ],
      radio: 'b',
      items: [
        { id: 1, name: "Option 1" },
        { id: 2, name: "Option 2" },
        { id: 3, name: "Option 3" },
      ],
      blank: ".",
    };
  },
  async mounted() {
    await this.$refs.email.validate();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-application code {
  margin-bottom: 8px;
}

.style-guide-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: 200px repeat(12, 1fr);
}

.menu {
  position: fixed;
  top: 130px;
  grid-column: 1;
}

.menu-link {
  display: block;
}

.colour-swatch {
  padding: 16px;
  width: fit-content;
  border: 1px solid var(--apio-shade-4);
  border-radius: 24px;
  filter: drop-shadow(0 0 0.75rem var(--apio-shade-4));
}

.apio-blue-black {
  background-color: var(--apio-blue-black);
  color: white;
}

.apio-magenta {
  background-color: var(--apio-magenta);
  color: white;
}

.apio-purple {
  background-color: var(--apio-purple);
  color: white;
}

.apio-cyan {
  background-color: var(--apio-cyan);
  color: var(--apio-blue-black);
}

.apio-shade-1 {
  background-color: var(--apio-shade-1);
  color: white;
}

.apio-shade-2 {
  background-color: var(--apio-shade-2);
  color: white;
}

.apio-shade-3 {
  background-color: var(--apio-shade-3);
  color: var(--apio-blue-black);
}

.apio-shade-4 {
  background-color: var(--apio-shade-4);
  color: var(--apio-blue-black);
}

.apio-shade-5 {
  background-color: var(--apio-shade-5);
  color: var(--apio-blue-black);
}

.apio-error {
  background-color: var(--apio-error);
  color: var(--apio-blue-black);
}

.apio-warning {
  background-color: var(--apio-warning);
  color: var(--apio-blue-black);
}

.apio-success {
  background-color: var(--apio-success);
  color: var(--apio-blue-black);
}

.style-guide {
  grid-column: 1/13;
  > .typography,
  > .colours,
  > .buttons-switches,
  > .tables,
  > .form-elements {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    > div > div:not(:last-child) {
      margin-bottom: 16px;
    }
  }


  .banners {
    display: grid;
    grid-template-columns: 1fr;

    > div > div:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .icons {
    display: grid;
    background-color: var(--apio-shade-2);
    grid-template-columns: repeat(8, 1fr);
    column-gap: 32px;
    > div > div:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}

.apio-button {
  margin-bottom: 16px;
}
</style>
